/* eslint-disable import/no-cycle */
import {executeGet, executePut} from '../requests';

const resourcesName = 'v1/mes-config';

export const MesConfigApi = {
  load: () => executeGet(resourcesName),
  update: (entity) => executePut(`${resourcesName}`, entity),
};
